(async () => {

  if (!customElements.get('product-recently-viewed')) {
    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");
    const {default: Cookies} = await import('js-cookie');

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay
    ]);

    class RecentlyViewedProducts extends HTMLElement {

      constructor() {
        super();
        this.initSwiper();
        this.writeCookie();
        this.render();
      }

      /**
       * initSwiper
       * @description Init the slider with the products.
       */
      initSwiper() {

        this.swiper = this.querySelector('[data-swiper]');
        this.swiperWrapper = this.querySelector('[data-swiper-wrapper]');

        this.swiperOptions = {
          direction: 'horizontal',
          loop: false,
          autoplay: false,
          spaceBetween: 0,
          threshold: 10,
          slidesPerGroup: 1,
          slidesPerView: 2.1,
          breakpoints: {
            360: {
              slidesPerView: 2.2
            },
            768: {
              slidesPerView: 2.5
            },
            1024: {
              slidesPerView: 3.2
            },
            1440: {
              slidesPerView: 3.4
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);

      }

      /**
       * readCookie
       * @description Reads the cookie from the browser.
       * @returns {Array}, list of product handles.
       */
      readCookie() {
        const viewedProducts = Cookies.get('viewedProducts');
        if(viewedProducts !== undefined) {
          return JSON.parse(viewedProducts);
        }
        return [];
      }

      /**
       * writeCookie
       */
      writeCookie() {
        // Get the current handle from data attribute
        const currentProductHandle = this.dataset.productHandle;
        // Read the cookie
        let productHandles = this.readCookie();
        // Filter the saved product handles first on the one from
        productHandles = productHandles.filter(productHandle => productHandle !== currentProductHandle);
        // Take
        let handles = productHandles.slice(-8);
        // Add it to the last one again
        handles.push(currentProductHandle);
        // Set the cookie, expires after 31 days.
        Cookies.set('viewedProducts', JSON.stringify(handles), { expires: 31 });
      }

      /**
       * Render
       * @description Fetch the ?view=recently-viewed for every product handle in the cookie.
       */
      async render() {

        // Get the current product handle
        const currentProductHandle = this.dataset.productHandle;

        // Read cookie
        let viewedProducts = this.readCookie();

        // Filter the list from the current product handle
        viewedProducts = viewedProducts.filter(handle => handle !== currentProductHandle);

        // Set in correct order to fetch
        const viewedProductHandlesInOrder = viewedProducts.slice(-8).reverse();

        // Create source where we can add all the fetch data to
        let source = document.createElement('div');

        // Get the data based on handle and only start with the other one after the fetch product is done
        const fetchProductData = async (handleIndex = 0) => {
          const handle = viewedProductHandlesInOrder[handleIndex];
          if (handle == '' || handle == ' '){
            fetchProductData(handleIndex + 1);
            return;
          } else {

            if (handle !== undefined) {
              try {
                const productItem = await fetch(`/products/${handle}?view=recently-viewed`)
                  .then(response => {
                    if (response.status !== 200 || response.status == 404) {
                      fetchProductData(handleIndex + 1);
                      throw new Error(response.status + ' ' + response.statusText);
                    }
                    return response.text();
                  })
                  .then(text => {
                    const parser = new DOMParser();
                    const html = parser.parseFromString(text, "text/html");
                    return html;
                  });

                source.append(productItem.querySelector('.swiper-slide'));

                // Check if we are done
                if (handleIndex + 1 === viewedProductHandlesInOrder.length) {
                  // Render result or hide the total section where there is nothing
                  if(source.childElementCount) {
                    // Replace old with new content
                    this.swiperWrapper.innerHTML = source.innerHTML;
                    // Call update method so the swiper so works
                    this.swiperInstance.update();
                    this.swiperInstance.navigation.init();
                    this.swiperInstance.navigation.update();
                    this.classList.remove('hidden');
                  } else {
                    this.classList.add('hidden');
                  }
                } else {
                  console.log('fetching next handle');
                  fetchProductData(handleIndex + 1);
                }

              }
              catch(error) {
                console.log(error);
              }
            } else {
              this.classList.add('hidden');
            }
          }
        }
        fetchProductData();
      }
    }

    window.RecentlyViewedProducts = RecentlyViewedProducts;
    customElements.define('product-recently-viewed', RecentlyViewedProducts);

  }

})();